<template>
    <div :id="`page-${data?.id}`" class="elle-page-content-full">
        <section class="elle-page-content-full-wrapper">
            <div class="container">
                <div class="grid12">
                    <div class="m-col">
                        <UiHeadline
                            :settings="{
                                label: data?.label,
                                headline: data?.headline
                            }"
                        />

                        <CommonContent :data="data?.content" />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script setup lang="ts">
defineProps({
    data: {
        type: Object,
        default: () => ({})
    }
});
</script>
